import styled from 'styled-components';

type Props = {
  className?: any;
};

function Seperator({ className }: Props) {
  return <SeperatorWrapper className={className} />;
}

const SeperatorWrapper = styled.div`
  border-top: 1px solid #ddd;
`;

export default Seperator;
